import { Location } from '@angular/common';
import { Component } from '@angular/core';
import {  Router } from '@angular/router';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrl: './otp-verification.component.scss'
})
export class OtpVerificationComponent {
  
  constructor(private location: Location,private router:Router){}
   
  goBackToPrevPage(){
    this.location.back();
  }
  submit(){
    this.router.navigate(['dashboard']);
}
}